import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PendingProductsSercice from '../../services/pendingProducts.service';
import PropTypes from 'prop-types';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Avatar, Chip, Paper, TableRow, TableHead, TableContainer, TableCell, TableBody, IconButton, Table, CircularProgress } from '@mui/material/';

const PendingProductsListTable = ({ pendingProducts, confirmApproval }) => {
  const [loading, setLoading] = useState({ productId: null, action: null });

  async function approveProduct(accountId, productId) {
    setLoading({ productId, action: 'approve' });
    try {
      const response = await PendingProductsSercice.approve(accountId, productId);
      if (response.data.success) {
        confirmApproval('The product was approved!');
      }
    } finally {
      setLoading({ productId: null, action: null });
    }
  }

  async function rejectProduct(accountId, productId) {
    setLoading({ productId, action: 'reject' });
    try {
      const response = await PendingProductsSercice.reject(accountId, productId);
      if (response.data.success) {
        confirmApproval('The product was rejected!');
      }
    } finally {
      setLoading({ productId: null, action: null });
    }
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="Pending products list">
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell></TableCell>
            <TableCell>Product Name</TableCell>
            <TableCell>Creator</TableCell>
            <TableCell>Price</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pendingProducts &&
            pendingProducts.map((product) => (
              <TableRow hover key={product.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {product.id}
                </TableCell>
                <TableCell>
                  {' '}
                  <Avatar alt={product.name} src={product.pics[0]?.url} />
                </TableCell>
                <TableCell>{product.name}</TableCell>
                <TableCell>
                  {
                    <Link to={`/accounts/${product.account.id}`} target="_blank">
                      {product.account.userName}
                    </Link>
                  }
                </TableCell>
                <TableCell>${(product.price[0].price / 100).toFixed(2)}</TableCell>
                <TableCell>
                  <Chip
                    label={product.price[0].paymentType === 'one_time' ? 'One-time' : 'Recurring'}
                    color={product.price[0].paymentType === 'one_time' ? 'default' : 'primary'}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <IconButton
                    aria-label="Approve product"
                    onClick={() => {
                      approveProduct(product.account.id, product.id);
                    }}
                    disabled={loading.productId !== null}
                    color="success"
                  >
                    {loading.productId === product.id && loading.action === 'approve' ? (
                      <CircularProgress size={24} />
                    ) : (
                      <CheckCircleIcon />
                    )}
                  </IconButton>
                  <IconButton
                    aria-label="Reject product"
                    onClick={() => {
                      rejectProduct(product.account.id, product.id);
                    }}
                    disabled={loading.productId !== null}
                    color="error"
                  >
                    {loading.productId === product.id && loading.action === 'reject' ? (
                      <CircularProgress size={24} />
                    ) : (
                      <CancelIcon />
                    )}
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

PendingProductsListTable.propTypes = {
  pendingProducts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  confirmApproval: PropTypes.func.isRequired
};
export default PendingProductsListTable;
